import { useState, useEffect } from 'react';

export const useIosDetection = () => {
    const [isIos, setIsIos] = useState(false);

    useEffect(() => {
        // A reliable way to check for iPhone, iPad, or iPod touch.
        const isDeviceIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        // We also check if the app is NOT already in standalone mode (i.e., installed)
        const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator.standalone);

        // Only show the prompt if it's an iOS device AND it's not already installed
        if (isDeviceIos && !isInStandaloneMode) {
            setIsIos(true);
        }
    }, []);

    return { isIos };
};